import React from 'react'

import { getAspectRatioPadding } from './utils/getAspectRatioPadding'

import { TIconProps } from './iconProps'

const IconArrowRight: React.FC<TIconProps> = (props) => {
  return (
    <div style={props.style} className={`select-none ${props.className || 'w-24'}`} onClick={props.onClick}>
      <div className="relative h-0" style={getAspectRatioPadding(props.aspectRatio)}>
        <svg xmlns="http://www.w3.org/2000/svg" className="w-full h-full left-0 top-0 absolute" viewBox="0 0 48 48">
          <path
            fill="currentColor"
            d="M24 2c1.026 0 1.871.772 1.987 1.767L26 4v35.168l10.586-10.582c.78-.781 2.047-.781 2.828 0 .721.72.777 1.855.167 2.64l-.167.188-14 14c-.07.071-.145.135-.223.193l-.223.144-.225.107-.284.09-.23.039L24 46l-.233-.013-.226-.04-.224-.067-.163-.067-.195-.105-.185-.127c-.073-.059-.132-.111-.188-.167l-14-14c-.781-.78-.781-2.047 0-2.828.72-.721 1.855-.777 2.64-.167l.188.167L22 39.17V4c0-1.105.895-2 2-2z"
            transform="rotate(-90 24 24)"
          />
        </svg>
      </div>
    </div>
  )
}

export default IconArrowRight
